import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import Dialog from '@/components/_custom/Dialog/Dialog'
import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './noChilds.module.scss'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { Add, WatchLater } from '@mui/icons-material'

interface noChildsDialogProps {
    open: boolean
    handleClose: () => void
    addChild: () => void
    nextStep?: () => void
}

const NoChildsDialog: FunctionComponent<noChildsDialogProps> = ({
    open,
    handleClose,
    addChild,
    nextStep
}: noChildsDialogProps) => {
    const { t } = useTranslation()

    function addNewChild(): void {
        handleClose()
        addChild()
    }

    function later(): void {
        if (nextStep) nextStep()
        handleClose()
    }

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('noChilds')} parent />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('noChildsAlert1')}</p>
                <p className={styles.Text}>{t('noChildsAlert2')}</p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('addChild')}
                        customIcon={<Add />}
                        onClick={addNewChild}
                        className={styles.Button}
                        parent
                        fullWidth
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('later')}
                        customIcon={<WatchLater />}
                        onClick={later}
                        className={styles.Button}
                        parent
                        fullWidth
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default NoChildsDialog
